"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineAsync = void 0;
const combine_recipe_1 = require("../recipes/combine-recipe");
const flatten_async_1 = require("./flatten-async");
const for_each_async_1 = require("./for-each-async");
const filter_async_1 = require("./filter-async");
const basic_ingredients_async_1 = require("./basic-ingredients-async");
exports.combineAsync = (0, combine_recipe_1.combineRecipe)({
    ...basic_ingredients_async_1.basicAsync,
    flatten: flatten_async_1.flattenAsync,
    forEach: for_each_async_1.forEachAsync,
    filter: filter_async_1.filterAsync,
});
